import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconBars24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="bars">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 14.3621L1.23179 2.64018C0.983388 2.3421 0.929843 1.92723 1.09442 1.57584C1.259 1.22446 1.61199 1 2.00001 1H22C22.388 1 22.741 1.22446 22.9056 1.57584C23.0702 1.92723 23.0166 2.3421 22.7682 2.64018L13 14.362V21H17C17.5523 21 18 21.4477 18 22C18 22.5523 17.5523 23 17 23H7.00002C6.44773 23 6.00002 22.5523 6.00002 22C6.00002 21.4477 6.44773 21 7.00002 21H11V14.3621ZM4.13505 3L19.865 3L12 12.438L4.13505 3Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
